import { StyleSheet } from 'react-native';
import { MBAnimationBounceIn } from '@shared/components/animation';
import { Colors, grid } from '@shared/styles';
import { IconButtonV2 } from './IconButtonV2';

export interface MBClearButtonProps {
  onPress: () => void;
  color?: string;
  backgroundColor?: string;
}

export function MBClearButton({
  onPress,
  color = Colors.v2.gray10,
  backgroundColor = Colors.v2.white,
}: MBClearButtonProps) {
  return (
    <MBAnimationBounceIn>
      <IconButtonV2
        name="remove-filled"
        onPress={onPress}
        size={grid(4.5)}
        color={color}
        style={[styles.button, { backgroundColor }]}
      />
    </MBAnimationBounceIn>
  );
}

const styles = StyleSheet.create({
  button: {
    margin: grid(1),
    width: grid(3),
    height: grid(3),
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
